import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, withKeys as _withKeys, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo_curisall_black_300x180.svg'


const _withScopeId = n => (_pushScopeId("data-v-fce51016"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "login" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "로그인")
], -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-title mb60" }, [
  /*#__PURE__*/_createElementVNode("p", null, "온라인 원격 상담 플랫폼에 오신 것을 환영합니다."),
  /*#__PURE__*/_createElementVNode("h2", { class: "mb40" }, "큐리스올"),
  /*#__PURE__*/_createElementVNode("h1", { class: "logo" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "큐리스올 로고"
    })
  ])
], -1))
const _hoisted_5 = {
  action: "",
  class: "login-form"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", { class: "hidden" }, "로그인", -1))
const _hoisted_7 = { class: "input-item mb10" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "userId",
  class: "hidden"
}, "아이디(이메일)", -1))
const _hoisted_9 = { class: "input-item mb20" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "userPw",
  class: "hidden"
}, "비밀번호", -1))
const _hoisted_11 = {
  key: 0,
  class: "msg-alert mb20"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { useStore } from 'vuex';
import { ref } from '@vue/reactivity';
import { watch } from 'vue';
interface Passwords {
  mode: string;
  title: string;
  description: string;
  alertMessage: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const store = useStore();
const Auth = store.state.moduleAuth;
/**** data -------------------- */
const userId = ref('');
const userPw = ref('');
const Password: Passwords = {
  mode: 'default',
  title: '',
  description: '',
  alertMessage: '',
};
/**** methods -------------------- */
const onClick_loginButton = () => {
  var userInfo = {
    userId: userId.value,
    userPw: userPw.value,
  };
  store.dispatch('moduleAuth/login', userInfo, { root: true });
};
var isOn_eyeslash = ref(false);
var onClick_eyeslash = () => {
  var pw = document.getElementById('userPw') as HTMLElement;
  if (isOn_eyeslash.value) {
    isOn_eyeslash.value = false;
    pw.setAttribute('type', 'password');
  } else {
    isOn_eyeslash.value = true;
    pw.setAttribute('type', 'text');
  }
};
/**** content -----------------
 *
 * 로그인
 * /
 * /
/**** hook -------------------- */
watch(
  () => userId.value,
  async (newValue: string) => {
    if (newValue === ``) {
      Auth.isLogin = false;
      Auth.isLoginError = false;
    }
  },
  { deep: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (Password.mode === 'default')
      ? (_openBlock(), _createElementBlock("main", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("form", _hoisted_5, [
            _createElementVNode("fieldset", null, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _withDirectives(_createElementVNode("input", {
                  class: "input-id",
                  type: "text",
                  name: "userId",
                  id: "userId",
                  placeholder: "아이디(이메일) 입력",
                  autofinished: "off",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(userId) ? (userId).value = $event : null))
                }, null, 512), [
                  [_vModelText, _unref(userId)]
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _withDirectives(_createElementVNode("input", {
                  class: "input-pw",
                  type: "password",
                  name: "userPw",
                  id: "userPw",
                  placeholder: "비밀번호 입력",
                  autofinished: "off",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(userPw) ? (userPw).value = $event : null)),
                  onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (onClick_loginButton()), ["enter"]))
                }, null, 544), [
                  [_vModelText, _unref(userPw)]
                ]),
                _createElementVNode("button", {
                  class: _normalizeClass(["btn-eyeslash", [{ on: _unref(isOn_eyeslash) }]]),
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_unref(onClick_eyeslash)()), ["prevent"])),
                  tabindex: "-1"
                }, "보안", 2)
              ]),
              _createVNode(_Transition, { name: "alertMsg" }, {
                default: _withCtx(() => [
                  (_unref(Auth).isLoginError)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
                        _createTextVNode(" 아이디 또는 비밀번호를 잘못 입력했습니다."),
                        _hoisted_12,
                        _createTextVNode(" 입력하신 내용을 다시 확인해주세요. ")
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createElementVNode("button", {
                class: "btn-confirm",
                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (onClick_loginButton()), ["prevent"]))
              }, "로그인")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})